export default function baseStore({ createState, set, get }) {
  return {
    data: createState?.() || {},
    setData: data => set({ data: { ...get().data, ...data } }),
    reset: () => {
      const store = get()
      return set({ ...store, data: createState?.() || {} }, true)
    },
    init: () => {
      if (!get().isInit) {
        window.removeEventListener('STORE_CLEAR', get().reset)
        window.addEventListener('STORE_CLEAR', get().reset)
        get().setData({ isInit: true })
      }
    },
  }
}
